import { useEffect, useState } from 'react';
import { fetchPendingCount } from '@/services/targets/targetsService';
import { TARGETS_CHANGED } from '@/services/targets/targetsEvents';
import { logError } from '@/services/logger';

/**
 * Proposals waiting for an admin; null = not fetched or failed (never shown as 0).
 * Refetches on `targets:changed`, which every successful write announces.
 */
export const usePendingTargetCount = (workspaceId: string | null, enabled: boolean): number | null => {
  const [count, setCount] = useState<{ key: string; n: number | null } | null>(null);
  const [tick, setTick] = useState(0);
  const key = enabled && workspaceId ? workspaceId : '';
  useEffect(() => {
    if (!key) return;
    const bump = () => setTick((n) => n + 1);
    window.addEventListener(TARGETS_CHANGED, bump);
    return () => window.removeEventListener(TARGETS_CHANGED, bump);
  }, [key]);
  useEffect(() => {
    if (!key) return;
    let ignore = false;
    fetchPendingCount(key).then(
      (n) => { if (!ignore) setCount({ key, n }); },
      (err: unknown) => {
        logError('usePendingTargetCount', 'pending count failed', err);
        if (!ignore) setCount({ key, n: null });
      },
    );
    return () => { ignore = true; };
  }, [key, tick]);
  return count && count.key === key ? count.n : null;
};
